/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineSharedClassModules200,
  GetApiV1ClassroomdisciplineSharedClassModules401,
  GetApiV1ClassroomdisciplineSharedClassModulesQueryParams,
  GetApiV1ClassroomdisciplineSharedClassModulesQueryResponse,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedClassModules.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1ClassroomdisciplineSharedClassModulesQueryParamsSchema = z
  .object({
    Search: z.optional(z.string()),
    Take: z.optional(z.coerce.number().int()),
    Culture: z.optional(z.string()),
    CourseId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassModulesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineSharedClassModules200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassModules200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineSharedClassModules401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassModules401>;

export const getApiV1ClassroomdisciplineSharedClassModulesQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineSharedClassModules200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassModulesQueryResponse>;
